(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EvaluationTemplateFile', EvaluationTemplateFile);

    EvaluationTemplateFile.$inject = ['$resource', 'DataUtils'];

    function EvaluationTemplateFile ($resource, DataUtils) {
        var resourceUrl =  'api/evaluation-template-files/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByEvaluationTemplate': {url: 'api/evaluation-template-files/by-evaluation-template', method: 'GET', isArray: true},
            'attachFiles': {url: 'api/evaluation-template-files/attach-files', method: 'POST', isArray: true},
            'download': {
                url: 'api/evaluation-template-files/get-file/:id',
                method: 'GET',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            }
        });
    }
})();
